import { ANALYTICS_HOST, WEBSITE_ID } from '@/constants';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var haQ: any[];
}

const SCRIPT_URL = `${ANALYTICS_HOST}/ha.js`;

(function () {
  const script = document.createElement('script');
  script.src = SCRIPT_URL;
  script.async = true;
  script.dataset.websiteId = WEBSITE_ID;
  document.head.appendChild(script);
})();

globalThis.haQ = globalThis.haQ || [];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function track(...args: any[]) {
  const timestamp = Math.floor(Date.now() / 1000);
  globalThis.haQ.push([timestamp, ...args]);
};

track({ title: 'Home', pathname: globalThis.location.pathname });
export default track;
